/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Role_Accounts_PayableInputs */

const en_contact_role_accounts_payable = /** @type {(inputs: Contact_Role_Accounts_PayableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accounts payable`)
};

/**
* | output |
* | --- |
* | "Accounts payable" |
*
* @param {Contact_Role_Accounts_PayableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_role_accounts_payable = /** @type {((inputs?: Contact_Role_Accounts_PayableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Role_Accounts_PayableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_role_accounts_payable(inputs)
});